import { Injectable, inject } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private readonly alertController = inject(AlertController);

  showSuccess(keyOrMessage: string, header?: string) {
    const message = keyOrMessage;

    this.alertController
      .create({
        header: header ? header : 'Operazione riuscita',
        message: message,
        buttons: [{ text: 'Chiudi' }],
      })
      .then((c) => c.present());
  }

  showError(keyOrMessage: string, header?: string) {
    const message = keyOrMessage;

    this.alertController
      .create({
        header: header ? header : 'Errore',
        message: message,
        buttons: [{ text: 'Chiudi' }],
      })
      .then((c) => c.present());
  }

  showWarning(keyOrMessage: string, header?: string) {
    const message = keyOrMessage;

    this.alertController
      .create({
        header: header ? header : 'Attenzione',
        message: message,
        buttons: [{ text: 'Chiudi' }],
      })
      .then((c) => c.present());
  }
}
